<template>
  <v-container class="orders-container">
    <span class="ma-3">
      <TitleChip title="Pedidos" />
    </span>
    <div
      v-if="isLoading"
      class="text-xs-center"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>

    <div v-else>
      <span
        v-if="!orders.length"
        class="no-orders-text"
      >
        Não há pedidos a serem listados
      </span>

      <div v-else>
        <OrderCard
          v-for="order in sortedOrders"
          :key="order._id"
          :order="order"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { everything } from '@sejazipper/layer-api-client';
import { mapGetters } from 'vuex';
import { useZipperApi } from '../composables/useZipperApi';

const { client } = useZipperApi();

export default {
  data: () => ({
    isLoading: false,
    orders: [],
    selectedTab: 'abertos',
  }),
  computed: {
    ...mapGetters(['getStore', 'isManager', 'isDirector', 'getCustomer', 'getProfile']),

    sortedOrders() {
      return _.orderBy(this.orders, 'updated_at', 'desc');
    },
  },
  async mounted() {
    this.$set(this, 'isLoading', true);
    const purchaseOrderInput = {
      customer_mongo_id: this.getCustomer.id,
      store_mongo_ids: [this.getStore.id],
    };

    const response = await client.chain.query
      .getPurchaseOrdersByCustomerId({ purchaseOrderInput })
      .get({
        ...everything,
        purchase_order_status: {
          ...everything,
        },
        client: {
          ...everything,
        },
      });

    if (this.isManager || this.isDirector) {
      this.orders = response;
    } else {
      this.orders = response.filter((item) => item.seller_name === this.getProfile.name);
    }
    this.$store.dispatch('setOrders', _.groupBy(this.orders, '_id'));
    this.$set(this, 'isLoading', false);
  },
};
</script>

<style lang="scss" scoped>
.orders-container {
  padding: 10px 0 80px 0;
}

.tabs-header {
  font-family: 'Neue-Metana';
  font-size: 18px;
}

.no-orders-text {
  display: block;
  font-family: 'Nunito Sans';
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
}
</style>
